<template>
  <div class="classroomArrangement">
    <div class="classroomArrangement-page">
      <div class="classroomArrangement-leftpage">
        <leftClassroomArrangement :data="leftData"></leftClassroomArrangement>
      </div>
      <div class="classroomArrangement-rightpage">
        <rightClassroomArrangement
          :data="rightData"
          @clickMore="clickMore"
        ></rightClassroomArrangement>
      </div>
    </div>
    <van-popup
      class="pop-page"
      v-model="show"
      position="center"
      get-container="#app"
      :closeable="true"
    >
      <div class="pop-content">
        <div class="pop-title">未开始安排</div>
        <div class="pop-list">
          <van-grid
            :column-num="3"
            :gutter="20"
            :border="false"
            v-if="rightData.length != 0"
          >
            <van-grid-item v-for="(item, index) in moreList" :key="index">
              <classroomArrangementMoreItem
                :item="item"
              ></classroomArrangementMoreItem>
            </van-grid-item>
          </van-grid>
          <div v-else class="arrange-nodata">
            <div class="content">
              <img
                :src="
                  require('_teas/public/img/product/bootScreen/img-null.png')
                "
                alt=""
                srcset=""
              />
              <div class="text">暂无当前课程/会议</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import leftClassroomArrangement from "./components/leftClassroomArrangement.vue";
import rightClassroomArrangement from "./components/rightClassroomArrangement.vue";
import classroomArrangementMoreItem from "./components/classroomArrangementMoreItem.vue";
// 教室安排横屏
export default {
  name: "classroomArrangement",
  components: {
    leftClassroomArrangement,
    rightClassroomArrangement,
    classroomArrangementMoreItem,
  },
  data() {
    return {
      leftData: [],
      rightData: [],
      moreList: [],
      show: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    clickMore() {
      this.show = true;
    },
    dealData(data) {
      var left = data["1"];
      if (left) {
        this.leftData = left;
      }
      var right = data["2"];
      if (right) {
        this.moreList = right;
        if (right.length > 10) {
          right = right.splice(0, 10);
        }
        this.rightData = this.chunk(right, 2);
      }
    },
    // 重新整理数据
    chunk(array, size) {
      let length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      let index = 0,
        resIndex = 0,
        result = Array(Math.ceil(length / size));
      while (index < length) {
        result[resIndex++] = array.slice(index, (index += size));
      }
      return result;
    },
    getData() {
      var loading = dsf.layer.loading();
      this.$http
        .get("teas/screen/getSameDayClassroomArrangement", {
          equipmentId: sessionStorage.getItem('equipmentId'),
        })
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            this.dealData(res.data);
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
};
</script>

<style>
</style>